import React from 'react';
import { Navigate } from 'react-router-dom';
import { isAdmin, isCompany, isCoordinator, isAuthenticated } from '../utils/auth';

function ProtectedRoute({ children, requireAdmin = false, requireCompany = false, requireCoordinator = false }) {
  if (!isAuthenticated()) {
    return <Navigate to="/login" replace />;
  }
  if (requireAdmin && !isAdmin()) {
    return <Navigate to="/" replace />;
  }
  if (requireCompany && !isCompany()) {
    return <Navigate to="/" replace />;
  }
  if (requireCoordinator && !isCoordinator()) {
    return <Navigate to="/" replace />;
  }

  return children;
}

export default ProtectedRoute;

